var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contratti-email-firma',{attrs:{"token":_vm.token}})}
var staticRenderFns = []

export { render, staticRenderFns }